import { TimelineMax, TweenMax } from "gsap/all";
import BezierEasing from './bezierCurve.js'

const BezierCurve = {
	nav:       new Ease(BezierEasing.css["nav"]),
	ease:      new Ease(BezierEasing.css["ease"]),
	easeNone:  new Ease(BezierEasing.css["linear"]),
	easeIn:    new Ease(BezierEasing.css["ease-in"]),
	easeOut:   new Ease(BezierEasing.css["ease-out"]),
	easeInOut: new Ease(BezierEasing.css["ease-in-out"])
};

export function navTimeline() {
	TweenMax.set($(`.nav__list-item .copy`), {
		yPercent: -50,
		xPercent: -50,
	});

	let navTL = new TimelineMax({ paused: true, reversed: true });
	navTL
		.set($(`body`), { overflow: 'hidden' })
		.set($(`.nav__bg, .slideBG`), { left: 0 })
		.set($(`.nav, .nav__content, .nav__bg, .slideBG`), { position: 'fixed' })
		.to($('.coupon_holder'), 0.5, { scale: 0, autoAlpha: 0, transformOrigin: '50% 50%', ease: BezierCurve.nav }, 0)
		.to($('#burger1'), 0.2, { yPercent: 325 }, 'cross', 0)
		.to($('#burger3'), 0.2, { yPercent: -325 }, 'cross', 0)
		.to($('#burger2'), 0.1, { autoAlpha: 0 }, 'cross', '-=0.05')
		.to($('#burger1'), 0.5, { rotation: 45, transformOrigin: '50% 50%', ease: BezierCurve.nav }, 'cross', '-=0.2')
		.to($('#burger3'), 0.5, { rotation: -45, transformOrigin: '50% 50%', ease: BezierCurve.nav }, 'cross', '-=0.2')

		.to($('.slideBG'), 0.01, { y: 64, ease: BezierCurve.nav }, '-=0.4')
		.to($('.bg1'), 0.8, { yPercent: 100, ease: BezierCurve.nav }, '-=0.01')
		.to($('.bg2'), 0.8, { yPercent: 100, ease: BezierCurve.nav }, '-=0.7')

		.staggerTo($('.nav__list-item'), 0.3, { yPercent: -100, opacity: 1, ease: BezierCurve.nav }, 0.2)
		.to($('.nav__social'), 0.3, { yPercent: 100, opacity: 1, ease: BezierCurve.nav })
	;
	return navTL;
};